import { render, staticRenderFns } from "./viewProductType.vue?vue&type=template&id=f610b8de&scoped=true&"
import script from "./viewProductType.vue?vue&type=script&lang=js&"
export * from "./viewProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f610b8de",
  null
  
)

export default component.exports